import React from "react";
import { motion } from "framer-motion";

export default function SamplingHistogram({ title, n, bins, sampleValues, truthValues, yMax, sampleMean, truthMean, min, max, standardError }) {
  const meanPosition = ((sampleMean - min) / (max - min)) * 100;
  const truthPosition = ((truthMean - min) / (max - min)) * 100;
  const delta = sampleMean - truthMean;

  return (
    <article className="histogram-card">
      <div className="histogram-card-head">
        <div>
          <span className="sample-size">n = {n.toLocaleString()}</span>
          <h3>{title}</h3>
        </div>
        <span className="accuracy-badge">0% measurement error</span>
      </div>

      <div className="histogram-chart" role="img" aria-label={`Histogram for an IID sample of ${n} perfectly measured birds`}>
        <div className="histogram-bars">
          {sampleValues.map((value, index) => {
            const sampleHeight = (value / yMax) * 100;
            const truthHeight = (truthValues[index] / yMax) * 100;
            return (
              <div className="histogram-bin" key={`${n}-${bins[index]}`}>
                <div className="truth-bar" style={{ height: `${truthHeight}%` }} />
                <motion.div
                  className="sample-bar"
                  initial={{ height: 0 }}
                  animate={{ height: `${sampleHeight}%` }}
                  transition={{ duration: 0.55, delay: index * 0.015, ease: [0.22, 1, 0.36, 1] }}
                />
              </div>
            );
          })}
        </div>

        <div className="truth-mean-line" style={{ left: `${truthPosition}%` }}>
          <span>truth</span>
        </div>
        <motion.div
          className="sample-mean-line"
          initial={false}
          animate={{ left: `${meanPosition}%` }}
          transition={{ type: "spring", stiffness: 180, damping: 24 }}
        >
          <span>{sampleMean.toFixed(0)} g</span>
        </motion.div>
      </div>

      <div className="histogram-axis">
        <span>{min} g</span>
        <span>{truthMean.toFixed(0)} g</span>
        <span>{max} g</span>
      </div>

      <div className="histogram-stats">
        <div>
          <span>Sample mean</span>
          <strong>{sampleMean.toFixed(1)} g</strong>
        </div>
        <div>
          <span>Difference from truth</span>
          <strong>{delta >= 0 ? "+" : ""}{delta.toFixed(1)} g</strong>
        </div>
        <div>
          <span>Expected sampling SE</span>
          <strong>≈ {standardError.toFixed(1)} g</strong>
        </div>
      </div>
    </article>
  );
}
